import { Checkbox, Col, Row, Typography } from "antd";
import { MazakaInput } from "apps/Common/MazakaInput";
import { FC } from "react";
import { useDebouncedCallback } from "use-debounce";

interface BaseOptionItemProps {
  item: any;
  selectedOptions: any;
  setSelectedOptions: any;
}
const BaseOptionItem: FC<BaseOptionItemProps> = ({
  item,
  selectedOptions,
  setSelectedOptions,
}) => {
  const handleDebouncedChange = useDebouncedCallback(
    (name: string, value: string,id) => {
      const allOptions = [...selectedOptions];

      const findOption = allOptions.find(
        (optionItem) => optionItem.name === name
      );
      if (findOption) {
        findOption["value"] = value;
      } else {
        let obj = { name, value, type: "input",key:id};

        allOptions.push(obj);
      }
      setSelectedOptions([...allOptions]);
    },
    1000
  );
  const {Text} = Typography
  return (
    <>
      {(() => {
        if (item.option.optionControlTypeId === 1) {
          return (
          //   <Row gutter={[0, 5]}>
          //   {item.option.optionValues.map((optionValueItem: any) => {
          //     const findOption = selectedOptions.find(
          //       (selectedItem: any) => selectedItem.key === item.option.id
          //     );
          //     let findTargetProperty = null;
          //     if (findOption) {
          //       findTargetProperty = findOption.values.find(
          //         (item: any) => item.key === optionValueItem.id
          //       );
              
          //     }
          //     return (
          //       <Col xs={24} className="!flex gap-2">
          //         <Checkbox
          //           checked={findTargetProperty ? findTargetProperty.value : false}
          //           onChange={(e) => {
          //             const status = e.target.checked;
                    
          //             const allOptions = [...selectedOptions];
                    
          //             const findOptionIndex = allOptions.findIndex(
          //               (optionItem) => optionItem.name === item.option.name
          //             );
                    
          //             if (findOptionIndex !== -1) {
          //               let updatedOption = { ...allOptions[findOptionIndex] };
                    
          //               // Eğer `values` array'i varsa, onu da yeni bir array olarak kopyala
          //               updatedOption.values = [...updatedOption.values];
                    
          //               // Seçili değeri bul
          //               const findSelectedOptionValueIndex = updatedOption.values.findIndex(
          //                 (optionValue: any) => optionValue.name === optionValueItem.value
          //               );
                    
          //               if (findSelectedOptionValueIndex !== -1) {
          //                 // Eğer mevcutsa yeni bir nesne oluşturup güncelle
          //                 updatedOption.values[findSelectedOptionValueIndex] = {
          //                   ...updatedOption.values[findSelectedOptionValueIndex],
          //                   value: status,
          //                 };
          //               } else {
          //                 // Yoksa yeni bir değer ekle
          //                 updatedOption.values.push({
          //                   name: optionValueItem.value,
          //                   value: status,
          //                   key: optionValueItem.id,
          //                 });
          //               }
                    
          //               // Güncellenmiş öğeyi array'e geri koy
          //               allOptions[findOptionIndex] = updatedOption;
          //             } else {
          //               // Eğer seçenek yoksa yeni bir tane oluştur
          //               const selectedOptionsItem = {
          //                 name: item.option.name,
          //                 values: [
          //                   {
          //                     name: optionValueItem.value,
          //                     value: status,
          //                     key: optionValueItem.id,
          //                   },
          //                 ],
          //                 key: item.option.id,
          //               };
          //               allOptions.push(selectedOptionsItem);
          //             }
                    
          //             setSelectedOptions([...allOptions]);
          //           }}
                    
      
          //           // name={optionValueItem.value}
          //         />
          //         <Text>{optionValueItem.value}</Text>
          //       </Col>
          //     );
          //   })}
          // </Row>
          <Row gutter={[0, 5]}>
  {item.option.optionValues.map((optionValueItem: any) => {
    const findOption = selectedOptions.find(
      (selectedItem: any) => selectedItem.key === item.option.id
    );
    let findTargetProperty = null;
    if (findOption) {
      findTargetProperty = findOption.values.find(
        (item: any) => item.key === optionValueItem.id
      );
    }
    return (
      <Col key={optionValueItem.id} xs={24} className="!flex gap-2">
        <Checkbox
          checked={findTargetProperty ? findTargetProperty.value : false}
          onChange={(e) => {
            const status = e.target.checked;
            const allOptions = [...selectedOptions];
            const findOptionIndex = allOptions.findIndex(
              (optionItem) => optionItem.name === item.option.name
            );
            if (findOptionIndex !== -1) {
              let updatedOption = { ...allOptions[findOptionIndex] };
              updatedOption.values = [...updatedOption.values];
              const findSelectedOptionValueIndex = updatedOption.values.findIndex(
                (optionValue: any) => optionValue.name === optionValueItem.value
              );
              if (findSelectedOptionValueIndex !== -1) {
                updatedOption.values[findSelectedOptionValueIndex] = {
                  ...updatedOption.values[findSelectedOptionValueIndex],
                  value: status,
                };
              } else {
                updatedOption.values.push({
                  name: optionValueItem.value,
                  value: status,
                  key: optionValueItem.id,
                });
              }
              allOptions[findOptionIndex] = updatedOption;
            } else {
              const selectedOptionsItem = {
                name: item.option.name,
                values: [
                  {
                    name: optionValueItem.value,
                    value: status,
                    key: optionValueItem.id,
                  },
                ],
                key: item.option.id,
              };
              allOptions.push(selectedOptionsItem);
            }
            setSelectedOptions([...allOptions]);
          }}
        />
        <Text>{optionValueItem.value}</Text>
      </Col>
    );
  })}
</Row>

          );
        } else if (item.option.optionControlTypeId === 2) {
          return (
            <>
              <MazakaInput
                xs={24}
              
                placeholder={item?.option?.name || ""}
    
                // name={item.id + "+input"}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const value = e.target.value;
                  if (value) {
                    handleDebouncedChange(item?.option?.name, value,item?.option?.id);
                  }
                }}
              />
            </>
          );
        }
        return <></>;
      })()}
    </>
  );
};

export default BaseOptionItem;
